import type { PaddleCatalogProduct, PaddleCatalogPrice } from '../../functions/src/common/paddleCatalogCache';
import { ENTERPRISE_BASE_PRODUCT_TYPE, isSubscriptionProductType, priceSubscriptionType } from '../../functions/src/common/paddleCatalogMetadata';

export interface SubscriptionProductGroup {
    type: string;
    name: string;
    products: PaddleCatalogProduct[];
}

export function groupSubscriptionProducts(products: PaddleCatalogProduct[]): SubscriptionProductGroup[] {
    const groups = new Map<string, SubscriptionProductGroup>();
    for (let index = 0; index < products.length; index++) {
        const product = products[index];
        if (product.status !== 'active' || !isSubscriptionProductType(product.customData.type))
            continue;
        const pricesBySubscription = new Map<string, PaddleCatalogPrice[]>();
        for (let priceIndex = 0; priceIndex < product.prices.length; priceIndex++) {
            const price = product.prices[priceIndex];
            const type = priceSubscriptionType(price.customData.subscription);
            if (!type || price.status !== 'active' || price.customData.checkout_purpose || price.customData.test_type === 'msa-cardless')
                continue;
            const prices = pricesBySubscription.get(type);
            if (prices)
                prices.push(price);
            else
                pricesBySubscription.set(type, [price]);
        }
        for (const [type, prices] of pricesBySubscription) {
            let group = groups.get(type);
            if (!group) {
                group = { type, name: type.replace(/[_-]+/g, ' ').replace(/\b\w/g, character => character.toUpperCase()), products: [] };
                groups.set(type, group);
            }
            group.products.push({ ...product, prices });
        }
    }
    const result = [...groups.values()].sort((left, right) => left.name.localeCompare(right.name));
    for (let index = 0; index < result.length; index++)
        result[index].products.sort((left, right) => Number(right.customData.type === ENTERPRISE_BASE_PRODUCT_TYPE) - Number(left.customData.type === ENTERPRISE_BASE_PRODUCT_TYPE) || left.name.localeCompare(right.name));
    return result;
}
